/* Pawable two-option buy box (Size x Bundle). Size chips filter the bundle pills;
   switching size keeps the same bundle tier selected. Otherwise mirrors
   pawable-bundle-picker.js: hidden variant/plan inputs, dual-price mode, CTA + sticky bar,
   AJAX add through Dawn's cart drawer. */
(function () {
  var form = document.querySelector('[data-pawable-drops]');
  if (!form) return;

  var pills = form.querySelector('[data-pawable-pills]');
  var variantInput = form.querySelector('#PawableBundleVariantId');
  var planInput = form.querySelector('#PawableSellingPlanInput');
  var subToggle = form.querySelector('[data-pawable-subscribe-toggle]');
  var ctaPrice = form.querySelector('[data-pawable-cta-price]');
  var ctaCompare = form.querySelector('[data-pawable-cta-compare]');
  var sizes = Array.prototype.slice.call(form.querySelectorAll('[data-pawable-size]'));
  var radios = Array.prototype.slice.call(form.querySelectorAll('[data-pawable-tier]'));
  if (!radios.length) return;

  var formatMoney = function (cents) {
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  // Sub mode is on whenever the toggle is checked; with no real plan input it is a
  // layout preview only and the cart receives the one-time price.
  var subMode = function () { return !!(subToggle && subToggle.checked); };

  var currentSize = function () {
    var s = sizes.filter(function (r) { return r.checked; })[0] || sizes[0];
    return s ? s.getAttribute('data-size-index') : null;
  };

  var selectedRadio = function () {
    return radios.filter(function (r) { return r.checked; })[0] || radios[0];
  };

  var applySize = function () {
    var size = currentSize();
    var tier = selectedRadio().getAttribute('data-tier-index');
    sizes.forEach(function (s) {
      s.closest('.pawable-sizes__chip').classList.toggle('is-selected', s.checked);
    });
    radios.forEach(function (r) {
      var match = r.getAttribute('data-size-index') === size;
      r.closest('.pawable-pills__option').hidden = !match;
      if (match && r.getAttribute('data-tier-index') === tier && !r.disabled) r.checked = true;
    });
  };

  var sync = function () {
    var radio = selectedRadio();
    variantInput.value = radio.getAttribute('data-variant-id');

    if (planInput) {
      planInput.value = subMode() ? radio.getAttribute('data-plan-id') || '' : '';
      planInput.disabled = !subMode();
    }
    var freqLabel = form.querySelector('[data-pawable-freq-label]');
    if (freqLabel && radio.getAttribute('data-plan-name')) freqLabel.textContent = radio.getAttribute('data-plan-name');

    if (pills) pills.classList.toggle('pawable-mode-sub', subMode());
    radios.forEach(function (r) {
      r.closest('.pawable-pills__option').classList.toggle('is-selected', r === radio);
    });

    var price = parseInt(subMode() ? radio.getAttribute('data-price-sub') : radio.getAttribute('data-price-once'), 10);
    var compare = parseInt(radio.getAttribute('data-compare-at'), 10) || parseInt(radio.getAttribute('data-price-once'), 10);
    if (ctaPrice) ctaPrice.textContent = formatMoney(price);
    if (ctaCompare) {
      ctaCompare.hidden = !(compare > price);
      if (compare > price) ctaCompare.textContent = formatMoney(compare);
    }

    var stickyPrice = document.querySelector('.pawable-sticky-atc__price');
    if (stickyPrice) stickyPrice.textContent = formatMoney(price);
    var stickyTitle = document.querySelector('.pawable-sticky-atc__title');
    var tierName = radio.closest('.pawable-pills__option').querySelector('.pawable-pills__title');
    var sizeChip = form.querySelector('.pawable-sizes__chip.is-selected .pawable-sizes__name');
    if (stickyTitle && tierName) {
      var base = stickyTitle.getAttribute('data-base-title') || stickyTitle.textContent.trim();
      stickyTitle.setAttribute('data-base-title', base);
      stickyTitle.textContent = base + ' · ' + (sizeChip ? sizeChip.textContent.trim() + ', ' : '') + tierName.textContent.trim();
    }
  };

  // Show the selected size's bottle in Dawn's media gallery.
  var showSizeMedia = function () {
    var gallery = document.querySelector('media-gallery[id^="MediaGallery-"]');
    var mediaId = selectedRadio().getAttribute('data-media-id');
    if (!gallery || !mediaId || typeof gallery.setActiveMedia !== 'function') return;
    var sectionId = gallery.id.replace('MediaGallery-', '');
    if (!gallery.querySelector('[data-media-id="' + sectionId + '-' + mediaId + '"]')) return;
    // Only the selected size's hero is visible; the other sizes' heroes stay hidden in gallery,
    // thumbnails and zoom modal so the same shot never appears twice.
    radios.map(function (r) { return r.getAttribute('data-media-id'); }).forEach(function (id) {
      var display = id === mediaId ? '' : 'none';
      document.querySelectorAll('[data-media-id="' + sectionId + '-' + id + '"], [data-target="' + sectionId + '-' + id + '"], ' +
        '.product-media-modal [data-media-id="' + id + '"]').forEach(function (el) { el.style.display = display; });
    });
    gallery.setActiveMedia(sectionId + '-' + mediaId, true);
    gallery.querySelectorAll('slider-component').forEach(function (s) { if (typeof s.resetPages === 'function') s.resetPages(); });
  };

  sizes.forEach(function (s) { s.addEventListener('change', function () { applySize(); sync(); showSizeMedia(); }); });
  radios.forEach(function (r) { r.addEventListener('change', sync); });
  if (subToggle) subToggle.addEventListener('change', sync);

  applySize();
  sync();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(showSizeMedia);
  } else {
    showSizeMedia();
  }

  form.addEventListener('submit', function (event) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function') return;
    event.preventDefault();
    var btn = form.querySelector('[data-pawable-add-to-cart]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var formData = new FormData(form);
    if (typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
    }
    // Free-gift tier: put the gift in the cart first (once), so the bundle's add renders both.
    var giftId = selectedRadio().getAttribute('data-gift-variant');
    var addGift = !giftId ? Promise.resolve() : fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var has = c.items.some(function (i) { return String(i.variant_id) === giftId && i.properties && i.properties._gift; });
        if (has) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(giftId, 10), quantity: 1, properties: { _gift: 'Free with Hemp Drops Buy 3 + get 2' } }] }),
        });
      })
      .catch(function () {});

    addGift
      .then(function () {
        return fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { form.submit(); return; }
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        cart.renderContents(state);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });
})();
